import { memoizeByAssetSource } from '@exodus/core-selectors/utils/memoize.js'
import { createSelector } from 'reselect'
import { getIncomingOrders } from './utils/incoming-orders.js'

export const selectorFactory = (ordersInProgressSelector) =>
  memoizeByAssetSource(({ walletAccount, assetName }) =>
    createSelector(ordersInProgressSelector, (orderSet) =>
      getIncomingOrders({ assetName, walletAccount, orderSet })
    )
  )

const createAssetSourceIncomingOrdersSelectorDefinition = {
  id: 'createAssetSourceIncomingOrders',
  selectorFactory,
  dependencies: [{ selector: 'ordersInProgress' }],
}

export default createAssetSourceIncomingOrdersSelectorDefinition
